import { Button, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';

import { ThinLecture } from '@/resources/ThinLecture';

interface IWatchOnUnderline {
  lecture: ThinLecture;
}

export const WatchOnUnderline: FC<IWatchOnUnderline> = ({ lecture }) => {
  const href = `/lecture/${lecture.id}-${lecture.slug}`;

  return (
    <NextLink href={href} target="_blank" rel="noopener noreferrer" passHref>
      <Button
        variant="unstyled"
        borderRadius={0}
        justifyContent="center"
        alignItems="center"
        bgColor="rgba(24,25,25, 0.8)"
        color="white"
        width="176px"
        height="56px"
        left={0}
        top="30px"
        position="absolute"
        fontFamily="heading"
      >
        Watch on{' '}
        <Text as="span" fontFamily="underline">
          u
        </Text>
        nderline
      </Button>
    </NextLink>
  );
};
